import React from 'react';
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {WarningImageBox} from "./boxes/warning-image/warning-image.box";
import {WarningTextBox} from "./boxes/warning-text/warning-text.box";
import {WarningMessageBox} from "./boxes/warning-message/warning-message.box";

export class RealMoneyOnlyWarningComponent extends OrbitComponent<{}>{
    render() {
        return(
          <WarningMessageBox>
              <WarningImageBox src={this.services.theme.currentTheme.images.onlyRealMoneyGameWarning.toString()}/>
              <WarningTextBox>{this.services.translation.translate('REAL_MONEY_GAME')}</WarningTextBox>
          </WarningMessageBox>
        );
    }
}